import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ViewableBy } from '../utilities/viewable-check'

export const HtmlBlockFragment: BlockFragment = {
  name: 'html',
  fragment: gql`
    fragment html on Html {
      id
      blockName
      blockType
      html
      htmlMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Html {
      id
      blockName
      blockType
      html
      htmlMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const HtmlBlockType = 'html'

export interface HtmlBlock extends BaseBlock {
  blockType: typeof HtmlBlockType
  html: string
  htmlMeta?: {
    viewableBy: [ViewableBy]
  }
}
